var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-collection"},_vm._l((_vm.devicesViewModel),function(device){return _c('div',{key:device.hash,staticClass:"device-item",class:{
        'device-item--second': _vm.isSecond(device)
      }},[_c('DeviceView',{attrs:{"device":device}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }